import React from 'react';
import { Helmet } from 'react-helmet';
import { connect } from "react-redux";
import { UiActions } from 'state/actions/UiActions';
import { PartnerAdminActions } from 'state/actions/user/PartnerAdminActions';
import { GlamboxComission } from './GlamboxComission';
import { OtherComissions } from './OtherComissions';


export class Comissions extends React.Component {
  constructor(props) {
    super(props);

    this.props.isAdmin(
      this.props.person.person.username,
      (response) => {
        const isAdmin = response.result;
        if (!isAdmin) {
          props.history.push("/");
        }
      });
  }
  
  gotoCreatePage = (e) =>{   
    e.preventDefault();
    const { history } = this.props;
    history.push('/admin/comissions/create');
  }

  render() {   

    return (
      <div className={"p-2 p-lg-5"}>
        <Helmet><title>Admin: Comissões</title></Helmet>
        <h1>Comissões</h1>

        <div  className={"pb-2"}>
        <button 
          className={"btn btn-light-pink btn-md"}
          onClick={this.gotoCreatePage}
          >
          Criar Comissões
        </button>
        </div>
        <GlamboxComission />
        <OtherComissions />
      </div>
    );
  }

}

const mapStateToProps = (state) => ({
  store: state,
  person: state.person.data,
  partnerGeneral: state.partnerGeneral.data,
  token: state.token.data.Authorization

});

const mapDispatchToProps = (dispatch) => ({
  loaderShow: () => {
    dispatch(UiActions.loaderShow());
  },
  loaderHide: () => {
    dispatch(UiActions.loaderHide());
  },
  publishSuccessAlert: (message) => {
    dispatch(UiActions.publishSuccessAlert(message));
  },
  publishErrorAlert: (message) => {
    dispatch(UiActions.publishErrorAlert(message));
  },
  isAdmin: (email, callback) => {
    dispatch(PartnerAdminActions.isAdmin(email, callback));
  }
});

Comissions = connect(
  mapStateToProps,
  mapDispatchToProps
)(Comissions);
